type VelaMarkProps = {
  size?: number;
  className?: string;
};

export function VelaMark({ size = 32, className = '' }: VelaMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Vela Wallet"
    >
      <rect width="32" height="32" rx="9" fill="url(#vela-tile)" />
      <path
        d="M16 7.5 L24.5 24 L16 19.4 L7.5 24 Z"
        fill="url(#vela-wing)"
      />
      <defs>
        <linearGradient id="vela-tile" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1a1f38" />
          <stop offset="1" stopColor="#0a0c16" />
        </linearGradient>
        <linearGradient id="vela-wing" x1="16" y1="7.5" x2="16" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8fe3d2" />
          <stop offset="1" stopColor="#2fb3a0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
